import * as Utils from "../utils";

// An `image` param: a picture a section declares a slot for, filled in from the
// site's own Images by whoever edits the page.
//
// The archived project's thirteenth param type, and one of the three the port
// left out — `../utils` recorded the reason as "needs a file service pagews
// does not have". It has one: a site's Images, and an anonymous URL a published
// page can actually read (docs/pagews-files.md §7).
//
// WHY IT IS ITS OWN DOCUMENT AND NOT `$ref: "/Image"`
//
// @repoflow/schema/utils already carries an `/Image`, it is already spread into
// every public schema here, and it is NOT this. Its `description` is a
// `/TextLang` — a map keyed by `en-US` and friends — because that package
// serves an app that localises. Nothing in pagews does: a section's params, a
// page's elements and a site's shell are all single-language, and a widget that
// rendered a language map for the alt text of one picture would be the only
// localised field in the service.
//
// Overriding it was not available either. Both documents would be in the same
// schema array, `SchemaLib.get` takes the FIRST match by id, and `/Image` comes
// in with UtilsSchema at the top of every public schema — so a second one would
// be dead weight that looks authoritative.
//
// So it is `/Types/Image`, named for where it is declared. The one thing to
// keep in step with it is the `image` branch of
// @repoflow/components/types-values, which generates the same object for a
// section's Values form and cannot import this file — types-values is a shared
// package and this is a pagews schema. That is the same split the `paragraph`
// param already lives with, where the contract is the widget name.
export const schema = [
  {
    id: "/Types/Image",
    type: "object",
    widget: "image",
    properties: {
      // Not `/URL`, which is `^https?://` and would refuse every URL the picker
      // produces — those are relative on purpose, so that one stored value
      // keeps working across every domain the site has and any change to them
      // (@common/schema/site-file/url). The scheme check that matters happens
      // where it becomes markup, in common/render/paragraph and in whatever
      // template reads this.
      url: { label: "Url", type: "string", default: "" },
      // The page's alt text. Seeded from the file's own description when one is
      // picked and editable afterwards — the file's belongs to the file, this
      // one belongs to the place it is used.
      description: { label: "Description", type: "string", default: "" },
    },
    default: { url: "", description: "" },
  },
  {
    id: "/Types/Param/Type/Image",
    type: "object",
    properties: {
      ...Utils.properties,
      // The slot's default picture. Not required — a section that declares an
      // image slot usually wants it empty until somebody fills it in, and a
      // required default would mean choosing a picture to declare the field.
      default: { label: "Default value", $ref: "/Types/Image" },
    },
    required: [],
  },
];
